import { Chip, Slider, Stack, styled, Typography } from '@mui/material';

export const StyledUserLoopSelector = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
}));

export const StyledFileInfoBox = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.grey[700],
  borderRadius: theme.spacing(0.5),
}));

export const StyledFileName = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  maxWidth: theme.spacing(17.5),
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}));

export const StyledInstrumentLabel = styled(Chip)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.grey[50],
}));

export const StyledEntropySliderContainer = styled(Stack)({});

export const StyledEntropySlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.grey[700],
  '& .MuiSlider-thumb': {
    backgroundColor: theme.palette.grey[50],
  },
  '& .MuiSlider-valueLabel': {
    fontSize: 12,
    padding: theme.spacing(0.25, 1),
  },
}));

export const StyledEntropyLabelsContainer = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const StyledEntropyTitle = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.grey[50],
}));

export const StyledEntropyLabel = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.grey[500],
}));
